/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import useSelectionsConferenceChampsData from '../../../state/selectionsAdminTool/UseSelectionsConferenceChampsData';
import UseForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';
import validate from './SelectionsAdminToolValidation';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import useReportPeriodSeasonData from '@usas/ui-web/state/reportPeriodSeason/UseReportPeriodSeasonData';
import useEmbeddedReportData from '@usas/ui-web/state/embeddedReport/UseEmbeddedReportData';

const INITIAL_FORM_STATE = {
  reportPeriodId: Constants.DEFAULT_ID,
  reportPeriodName: '',
  hostOrgUnitId: Constants.DEFAULT_ID,
  orgUnitName: ''
};

const INITIAL_VIEW_STATE = {
  reportParameters: { Id: 0 }, // report doesn't need a parameter but we have to have one here for this to work.
  routeName: '',
  isLoading: false,
  reportViewerType: '',
  reportName: ''
};

const useSelectionsAdminTool = () => {
  const {
    selectionsConferenceChampsState,
    getSelectionConferenceChamps,
    putSelectionConfirmNCAAConfChamps,
    putSelectionProcessNCAAConfChamps,
    putSelectionClearNCAAConfChampsConfirmation
  } = useSelectionsConferenceChampsData();
  const [filterState, setFilterState] = useState({ filteredData: [], isFiltered: false, isFiltering: true });
  const { reportPeriodSeasonState } = useReportPeriodSeasonData();
  const { formState, errorState, onValueTextPairChanged, handleSubmit } = UseForm(INITIAL_FORM_STATE, submitFormCallback, validate);
  const { NCAA_ORGANIZATION_ID } = useEnvironmentVariableData();
  const { reportListState, getEmbeddedReportListForRoute } = useEmbeddedReportData();

  const [viewState, setViewState] = useState(INITIAL_VIEW_STATE);

  function submitFormCallback(formState) {
    filter(formState);
  }

  const onProcessConferenceChampsClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const putSelectionProcessNCAAConfChampsPromise = putSelectionProcessNCAAConfChamps();
    if (putSelectionProcessNCAAConfChampsPromise ?? false) {
      putSelectionProcessNCAAConfChampsPromise.then((newState) => {
        if (newState ?? false) {
          // nothing to do yet
        }
      }).catch((e) => {
        // onNTGroupsError(e);
        console.error('Error in putSelectionProcessNCAAConfChampsPromise:', e);
      });
    }
  };

  const onClearStatusClicked = (e, ncaaConferenceChampionsId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const putSelectionClearNCAAConfChampsConfirmationPromise = putSelectionClearNCAAConfChampsConfirmation(ncaaConferenceChampionsId);
    if (putSelectionClearNCAAConfChampsConfirmationPromise ?? false) {
      putSelectionClearNCAAConfChampsConfirmationPromise.then((newState) => {
        if (newState ?? false) {
          // nothing to do yet
        }
      }).catch((e) => {
        // onNTGroupsError(e);
        console.error('Error in putSelectionClearNCAAConfChampsConfirmationPromise:', e);
      });
    }
  }

  const onFilterClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    handleSubmit();
  };

  const onRunReportClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setViewState({
      ...viewState,
      reportParameters: { Id: 0 }, // report doesn't need a parameter but we have to have one here for this to work.
      routeName: 'SELECTIONS_ADMIN_TOOL',
      isLoading: true,
      reportViewerType: 'ActiveReports',
      reportName: 'NCAA Conference Champions Report'
    });
  };

  const onSubmitChampionsFormGrid = (champsArray) => {
    try {
      const putSelectionConfirmNCAAConfChampsPromise = putSelectionConfirmNCAAConfChamps(champsArray);

      if (putSelectionConfirmNCAAConfChampsPromise ?? false) {
        putSelectionConfirmNCAAConfChampsPromise.then((newState) => {
          if (newState ?? false) {
            // nothing to do yet
          }
        }).catch((e) => {
          // onNTGroupsError(e);
          console.error('Error in putSelectionConfirmNCAAConfChampsPromise:', e);
        });
      }
    } catch (e) {
      //onNTGroupsError(e);
      console.error('Error in onSubmitAthletesFormGrid:', e);
    }
  };

  function getSelectionConferenceChampions() {
    const getSelectionConferenceChampsPromise = getSelectionConferenceChamps();

    if (getSelectionConferenceChampsPromise !== null) {
      getSelectionConferenceChampsPromise.then((newState) => {
        if (newState !== null) {
          // do something with newState if needed
        }
      }).catch((e) => {
        //TODO context error
      });
    }
  }

  function filter(formState) {
    setFilterState({
      ...filterState,
      isFiltered: false,
      isFiltering: true,
      filteredData: []
    });

    const selectedReportPeriodId = formState.reportPeriodId;

    setFilterState({
      ...filterState,
      isFiltered: true,
      isFiltering: false,
      filteredData: selectionsConferenceChampsState.arrayData.filter(
        item => item.reportPeriodId === selectedReportPeriodId && item.hostOrgUnitId === formState.hostOrgUnitId
      )
    });
  }

  useEffect(() => {
    getSelectionConferenceChampions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectionsConferenceChampsState.isArrayLoaded === true && reportPeriodSeasonState.isArrayLoaded === true) {
      filter(formState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionsConferenceChampsState, reportPeriodSeasonState]);

  useEffect(() => {
  if (viewState.routeName) {
    const reportListPromise = getEmbeddedReportListForRoute(viewState.routeName);

    if (reportListPromise) {
      reportListPromise.then((stateObj) => {
        if (Array.isArray(stateObj.arrayData)) {
          const reportIdx = stateObj.arrayData.findIndex(x => x.reportName === viewState.reportName);

          setViewState({
            ...viewState,
            isLoading: false,
            showReport: stateObj.arrayData.length > 0,
            reportInfoId: stateObj.arrayData[reportIdx].reportInfoId,
          });
        } else {
          setViewState({
            ...viewState,
            isLoading: false,
            showReport: false,
            reportInfoId: -1
          });
        }
      }).catch((err) => {
        setViewState({
          ...viewState,
          isLoading: false,
          showReport: false,
          reportInfoId: -1
        });
      });
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [viewState.routeName, viewState.reportViewerType]);

  return {
    selectionsConferenceChampsState,
    filterState,
    formState,
    errorState,
    viewState,
    setViewState,
    onValueTextPairChanged,
    onSubmitChampionsFormGrid,
    onFilterClicked,
    onClearStatusClicked,
    onProcessConferenceChampsClicked,
    onRunReportClicked,
    NCAA_ORGANIZATION_ID,
    INITIAL_VIEW_STATE
  }
};

export default useSelectionsAdminTool;